import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface FinaliseDialogComponentInput {
  changeoverId: string,
  ongoingTasks: Array<{ id: string; name: string }>,
  tasksWithNotesNeeded: Array<string>,
  onSubmit: () => Promise<void>,
}

@Component({
  selector: 'app-finalise-dialog',
  templateUrl: './finalise-dialog.component.html',
  styleUrls: ['./finalise-dialog.component.scss']
})
export class FinaliseDialogComponent implements OnInit {
  isBusy = false;
  errorMessage: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<FinaliseDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public model: FinaliseDialogComponentInput
  ) { }

  ngOnInit(): void {
  }

  async onSubmit() {
    this.isBusy = true;
    await this.model.onSubmit().catch(error => this.errorMessage = error.message);
    this.isBusy = false;
    if (this.errorMessage == null) {
      this.dialogRef.close(true);
    }
  }
}
